// This is the "common" entry-point for webpack
// It should include all common, shared and vendor resources to be webpack-ed, that are not specific to this app.

// Ensure support for "async" and friends (required now by ValidatorJS)
// import 'babel-polyfill'

// Include required Font Awesome 5 resources for iconography

// SVG Version:
// Depends: @fortawesome/fontawesome
// Optional: @fortawesome/fontawesome-free-brands @fortawesome/fontawesome-free-regular @fortawesome/fontawesome-free-solid
// require('./font-awesome-svg')

// Web Font Version - works better for Pseudo Elements:
// Free ones:
// require('./sass/font-awesome-webfonts.scss')
// Pro Fonts
require("@fortawesome/fontawesome-pro/css/light.css");
require("@fortawesome/fontawesome-pro/css/regular.css");
require("@fortawesome/fontawesome-pro/css/solid.css");
require("@fortawesome/fontawesome-pro/css/brands.css");
require("@fortawesome/fontawesome-pro/css/fontawesome.css");

// Add Import/Require lines for additional modules, including KendoUI, etc...
// See doc/client.md for more details and examples!
// import 'kendo-ui-core/css/web/kendo.common-material.core.css'
// import 'kendo-ui-core/css/web/kendo.material.css'
// require('kendo-ui-core/js/kendo.datepicker')

// Which set of core static resources to load based on layout
// require('./js/layouts/mu2022.js')

// require('./js/validator.js')
// res.locals.baseurl+'/js/validator.min.js',
// res.locals.baseurl+'/js/rightnow-survey.js',
// res.locals.baseurl+'/js/spin.min.js',
// res.locals.baseurl+'/js/jquery.spin.js',

// Bootstrap JS tools
import "bootstrap";
import 'form-serializer'

// Application custom style
import "./sass/application.scss"

module.exports = exports = {
   // Hook to allow triggering actions on page load
   onDocumentReady: (callback) => { $(document).ready(callback) },
   jQuery
}
